import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { IAppState } from "../store/states/app";
import { BootAttempt } from "../store/actions/boot";
import { selectAppBootState } from "../store/selectors";
@Injectable()
export class AppInitService {
  constructor(private _store: Store<IAppState>) {}
  /**
   * app initializer
   */
  initilize() {
    return new Promise<void>((resolve, reject) => {
      /**
       * Subscribe to boot state and resolve or reject app loading
       */
      this._store.select(selectAppBootState).subscribe((state) => {
        if (state.status === true) {
          resolve();
        }
        //Failed staff...
      });

      /**
       * Try to boot application
       */
      this._store.dispatch(new BootAttempt({ boot: "please :)" }));
    });
  }
}
